<template>
  <div>
    <v-app-bar app light dense color="primary">
      <v-toolbar-title>
        <span @click="priscilla()" class="white--text" >Priscilla</span>
      <v-icon @click="priscilla()" class="white--text" >mdi-watch</v-icon>
      </v-toolbar-title>
      <v-spacer></v-spacer>
  
      <v-toolbar-items>
        <!-- ps: pridal som class a color  -->
        <v-btn @click="register()" small class="white--text" color="buttonColor" v-if="!isLogged">Register</v-btn>
        <v-btn @click="login()" small class="white--text" color="buttonColor" v-if="!isLogged">Login</v-btn>
        <v-btn @click="dashboard()" small class="white--text" color="buttonColor" v-if="isLogged"> DashBoard</v-btn>
        <v-btn @click="categories()" small class="white--text" color="buttonColor" v-if="isLogged">Categories</v-btn>
        <v-btn v-if="isLogged" small class="white--text" color="buttonColor" @click="logout">Logout</v-btn>
        
      </v-toolbar-items>

        <v-menu
          v-if = "isLogged"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ on }">
            <v-app-bar-nav-icon v-on="on"></v-app-bar-nav-icon>
             
          </template>
        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John">
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>It is me</v-list-item-title>
              </v-list-item-content>

            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list>
            <v-list-item>
              <v-list-item-title @click="showLeaderBoard()">Leader board</v-list-item-title>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list>
            <v-list-item>
              <v-list-item-title @click="showProfile()">My profile</v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title @click="changePassword()">Change password</v-list-item-title>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>
          <v-card-actions>            
            <v-btn @click="logout" width = "100%" color="primary" text>Logout</v-btn>
          </v-card-actions>
        </v-card>
    </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      menu: false
    }
  },
  computed: 
        mapGetters([
                        'isLogged',
                        'isAdmin'
                    ])
  ,
  methods: {
    logout() { this.menu = false, this.$store.dispatch('logout') },
    register() { this.$router.push({name:'register', params: {}})  },
    login() { this.$router.push({name:'login', params: {}})  },
    dashboard() { this.$router.push({name:'dashboard', params: {}})  },   
    categories() { this.$router.push({name:'categories', params: {}})  }, 
    showProfile() { 
      this.menu = false 
      this.$router.push({name:'profile', params: {}}) 
    },
    changePassword() { 
      this.menu = false 
      this.$router.push({name:'pwdchange', params: {}}) 
    },
    showLeaderBoard() {
      this.menu = false 
      this.$router.push({name:'leaderboard', params: {}}) 
    },
    priscilla() { 
      if (this.isLoged) 
         this.$router.push({name:'dashboard', params: {}})  
        else
          this.$router.push({name:'login', params: {}})  

    } 
  }
}
</script>

<style>
.mybutton {
 padding-left: 16px;
 border: 1px solid red;
}

</style>